"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const CultureScheduleItem_1 = require("./CultureScheduleItem");
class CultureScheduleList extends React.Component {
    constructor() {
        super(...arguments);
        this.itemsPerPage = 10;
        this.state = {
            itemsDisplayed: this.itemsPerPage
        };
        this.openMore = () => {
            this.setState({
                itemsDisplayed: this.state.itemsDisplayed + this.itemsPerPage
            });
        };
    }
    componentWillReceiveProps() {
        this.setState({
            itemsDisplayed: this.itemsPerPage
        });
    }
    render() {
        const { date, showTicketCount } = this.props;
        if (this.props.events === null) {
            return (React.createElement("div", { className: "level is-center" },
                React.createElement("div", { className: "spinner" },
                    React.createElement("div", { className: "dot-1" }),
                    React.createElement("div", { className: "dot-2" }),
                    React.createElement("div", { className: "dot-3" }))));
        }
        if (!date) {
            return (React.createElement("div", { className: "level is-center" },
                React.createElement("h2", null, "Vi har for tiden ingen arrangementer. Flere vil bli lagt til senere.")));
        }
        return (React.createElement("div", { className: "event-container" },
            this.props.events.slice(0, this.state.itemsDisplayed).map((event, index) => (React.createElement(CultureScheduleItem_1.CultureScheduleItem, { key: index, event: event, showTicketCount: showTicketCount }))),
            this.props.events.length > this.state.itemsDisplayed &&
                React.createElement("div", { className: "level is-center" },
                    React.createElement("button", { className: "button is-contained", onClick: this.openMore }, "Se flere"))));
    }
}
exports.CultureScheduleList = CultureScheduleList;



// WEBPACK FOOTER //
// ./~/@dialogexe/cw-component-culture-schedule/CultureScheduleList.tsx